import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export default function useFetch(url, initial = null) {
  const [data, setData] = useState(initial);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let live = true;
    setLoading(true);
    api.get(url)
      .then((r) => { if (live) { setData(r.data); setError(null); } })
      .catch((e) => { if (live) setError(e); })
      .finally(() => { if (live) setLoading(false); });
    return () => { live = false; };
  }, [url]);

  return { data, loading, error };
}
